export const recentLocationAddress = (location = {}) => (
  location.address || [location.city, location.zip_code].filter(Boolean).join(', ')
);

export const recentLocationToSelectedPlace = (location = {}) => {
  const address = recentLocationAddress(location);
  const name = location.location_name || address;
  return {
    inputLabel: name && address && name !== address ? `${name} | ${address}` : (name || ''),
    location_name: location.location_name || address || '',
    formatted_address: location.address || '',
    city: location.city || '',
    zip_code: location.zip_code || '',
    place_id: location.place_id || null,
    lat: Number.isFinite(location.latitude) ? location.latitude : undefined,
    lng: Number.isFinite(location.longitude) ? location.longitude : undefined,
    isRecentLocation: true,
  };
};

export const isValidSelectedLocation = (place) => Boolean(
  place && (place.place_id || place.isRecentLocation)
);

export const applySelectedLocationToForm = (formData, place) => ({
  ...formData,
  location_name: place.location_name || '',
  city: place.city || '',
  zip_code: place.zip_code || '',
});
